module.exports = __webpack_public_path__ + "static/media/RPV_500.32798e72.png";